import type { ReactNode } from "react"

type Props = {
  eyebrow?: ReactNode    // accepts plain text OR a Link / breadcrumb React node
  title: string
  subtitle?: ReactNode   // string OR composed badges/links
  actions?: ReactNode
}

// Standard page header — eyebrow / title / optional actions on the right.
// Used at the top of every Inertia page so the spacing + type stays uniform.
export function PageHeader({ eyebrow, title, subtitle, actions }: Props) {
  return (
    <section className="flex items-center justify-between">
      <div>
        {eyebrow && <div className="text-sm text-app-muted">{eyebrow}</div>}
        <h1 className="mt-1 text-3xl font-semibold tracking-tight">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-app-muted">{subtitle}</p>}
      </div>
      {actions && <div className="flex gap-3">{actions}</div>}
    </section>
  )
}
